import * as React from 'react';

import styles from './Footer.module.scss';

export const Footer = () => (
  <footer className={styles.appFooter}>
    Copyright © 2015-2019 Nextiva Communications
  </footer>
);
